import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "location",
  "use": "location-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" id=\"location\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-linejoin=\"round\"><path d=\"M19.522 13.26a3.26 3.26 0 110 6.523 3.26 3.26 0 010-6.522z\" /><path d=\"M19.522 10a6.522 6.522 0 016.521 6.522c0 2.962-4.412 10.391-5.978 12.752a.653.653 0 01-1.087 0C17.412 26.913 13 19.484 13 16.522A6.522 6.522 0 0119.522 10z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol